/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-use-before-define */
/* eslint-disable no-nested-ternary */
import React, { useEffect, memo, useMemo, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Button, Col, Row, Label, Input } from 'reactstrap';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRedo, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

import {
  addAction,
  changeAction,
  disableAction,
  enableAction,
} from '../../../../../actions/BoxSessionLogging';
import {
  activateE2,
  activateE3,
  addPortForward,
  deactivateE2,
  deactivateE3,
  getDhcp,
  disableDHCP,
  enableDHCP,
  eSIMStatus,
  getPortList,
  updatePortForward,
  getNetworkConnectivatyStatus,
  triggerConnectivityStats,
  fetchNetworkInfo,
  refreshDhcp,
  enableDisableEth3,
  updateLowMtu,
  getLowMtu
} from '../../../../../actions/EpikBoxes';
import { TOOLTIPS_TEXT, ETH3_WARNING_TEXT } from '../../../../../lib/constants';
import InfoPopup from '../../../../InfoPopup';
import CustomModal from '../../../../CustomModal';
import TableRowData from '../../../../FulFillment/TableRowData';
import SpinnerCircles from '../../../../Spinner/SpinerCircles';
import Spinner from '../../../../Spinner/Spinner';
import PortForwardUpdate from '../EpikboxOptions/PortForwardUpdate';
import './EpikboxNetworking.css';
import NetworkInput from './NetworkInput';
import useEpikboxNetworking from './useEpikboxNetworking';
import utils from '../../../../../lib/utils';
import Toggle from '../../../../Toggle';
import ConfirmationModal from '../../../../ConfirmationModal';
import AddSecurityCodeModal from '../../../../AddSecurityCodeModal';
import { PIN_CODES_NAME } from '../../../../../utils/constants';
import addNote from '../../../../../lib/api/addNote';
import { getPermissionForComponent } from '../../../../../utils/permissionsUtils';
import { useUnifiedFetch } from '../../../../../hooks/useUnifiedFetch';
import TooltipCustom from '../../TooltipCustom';


const EpikboxNetworking = memo((props) => {
  const boxDetails = useSelector(state => state?.AppState?.boxDetails?.box);
  useEffect(() => {
    console.log('boxDetails updated:', boxDetails);
  }, [boxDetails]);
  const user = useSelector(state => state.AppState.user);
  const token = localStorage.getItem('jwtToken') || '';
  const dispatch = useDispatch();
  const [dcUpdatePopup, setDcUpdatePopup] = useState({ show: false, value: {} });

  const [updatedBoxDetails, setUpdatedBoxDetails] = useState(boxDetails);
  const [networkInfo, setNetworkInfo] = useState({});
  const [e1Strings, setE1Strings] = useState(
    boxDetails?.e2 ? {
      ...boxDetails.e2,
      ipType: boxDetails.e2.ipType || (boxDetails.e2.enabled ? 'static' : 'dhcp'),
      identity: boxDetails.e2.identity || '',
      password: boxDetails.e2.password || '',
      phase2: boxDetails.e2.phase2 || 'PEAP',
    } : {
      enabled: false,
      IP: '',
      subnet: '',
      gateway: '',
      ipType: 'dhcp', // 'dhcp', 'static', 'dhcp_8021x'
      identity: '',
      password: '',
      phase2: 'PEAP',
    },
  );
  const [e2Strings, setE2Strings] = useState({
    enabled: true,
    IP: '172.17.17.100',
    subnet: '255.255.255.0',
    gateway: '172.17.17.254',
  });

  const [warningModal, setWarningModal] = useState(false);
  const [warningModalText, setWarningModalText] = useState('');
  const [passwordModal, setPasswordModal] = useState(false);
  const [show8021xWarning, setShow8021xWarning] = useState(false);
  const [pending8021xSelection, setPending8021xSelection] = useState(null);

  const {
    mode,
    sec,
    loading,
    modeDropDown,
    secDropDown,
    showWifiSection,
    wifiStatus,
    handleDropDownChange,
    setWifiStatus,
    handleConnectDisconnect,
  } = useEpikboxNetworking(boxDetails, token);

  // const [wifiObject, setWifiObject] = useState();
  const [e2Toggle, setE2Toggle] = useState(boxDetails?.e3);
  const [forwardingModal, setForwardingModal] = useState(false);
  const [portList, setPortList] = useState([]);
  const [portLoading, setPortLoading] = useState(false);
  const [enableE1Btn, setEnableE1Btn] = useState(true);
  const [eSimStatus, setESIMStatus] = useState(null);
  const [toggleLoading, setToggleLoading] = useState(false);
  const [DHCPStatus, setDHCPStatus] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isModelGen4, setIsModelGen4] = useState(boxDetails?.model?.startsWith("G4"));
  const [dot1xPollingInterval, setDot1xPollingInterval] = useState(null);
  const [dot1xTimerInterval, setDot1xTimerInterval] = useState(null);
  const [dot1xStatusMessage, setDot1xStatusMessage] = useState(null);
  const [dot1xStartTime, setDot1xStartTime] = useState(null);
  const [dot1xRemainingTime, setDot1xRemainingTime] = useState(null);
  const [dot1xHideTimer, setDot1xHideTimer] = useState(null);
  const dot1xTimestampRef = useRef(null);
  const eth3Access = getPermissionForComponent('eth3Access',user.permissionsGroup);
  const outboundLowMTU = getPermissionForComponent('outboundLowMTU',user.permissionsGroup)
  const [lockLowMtuUI, setLockLowMtuUI] = useState(false);
  const OUTBOUND_LOW_MTU_OPTIONS = [1420,1375, 1350, 1325, 1300, 1275, 1250];
  const [outboundLowMtuEnabled, setOutboundLowMtuEnabled] = useState();
  const [outboundLowMtuValue, setOutboundLowMtuValue] = useState("");
  const [outboundLowMtuSaving, setOutboundLowMtuSaving] = useState(false);

  // E1 IP Type dropdown options
  const e1IpTypeOptions = [
    { label: 'DHCP', value: 'dhcp' },
    { label: 'Static', value: 'static' },
    { label: 'DHCP + Wired auth (802.1x)', value: 'dhcp_8021x' }
  ];

  const handleE1IpTypeChange = async (option) => {
    // If 802.1x is selected, show warning first
    if (option.value === 'dhcp_8021x') {
      setPending8021xSelection(option);
      setShow8021xWarning(true);
      return;
    }
    
    setE1Strings({ ...e1Strings, ipType: option.value });
    
    // Reset 802.1x related states when changing away from dhcp_8021x
    if (option.value !== 'dhcp_8021x') {
      setAreCredentialsSaved(false);
      setIsEditing8021x(false);
      setShowPassword(false);
      setE1Strings(prev => ({ ...prev, phase2: 'PEAP' }));
      // Clear dot1x status message and stop polling
      setDot1xStatusMessage(null);
      if (dot1xPollingInterval) {
        clearInterval(dot1xPollingInterval);
        setDot1xPollingInterval(null);
      }
      if (dot1xTimerInterval) {
        clearInterval(dot1xTimerInterval);
        setDot1xTimerInterval(null);
      }
      setDot1xStartTime(null);
      dot1xTimestampRef.current = null;
      setDot1xRemainingTime(null);
    }
    
    // If DHCP is selected, automatically call handleDeactivateE1
    if (option.value === 'dhcp') {
      setDhcpRequestLoading(true);
      try {
        await handleDeactivateE1();
      } catch (error) {
        console.error('Error saving DHCP configuration:', error);
      } finally {
        setDhcpRequestLoading(false);
      }
    }
  };

  const handle8021xFieldChange = (field, value) => {
    setE1Strings({ ...e1Strings, [field]: value });
  };

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleEdit8021x = () => {
    setIsEditing8021x(true);
  };

  const handleClear8021x = () => {
    setE1Strings({ ...e1Strings, identity: '', password: '', phase2: 'PEAP' });
    setIsEditing8021x(false);
    setAreCredentialsSaved(false);
  };

  const handle8021xWarningConfirm = () => {
    if (pending8021xSelection) {
      setE1Strings({ ...e1Strings, ipType: pending8021xSelection.value });
    }
    setShow8021xWarning(false);
    setPending8021xSelection(null);
  };

  const handle8021xWarningCancel = () => {
    setShow8021xWarning(false);
    setPending8021xSelection(null);
    // Reset dropdown to previous value
    setE1Strings({ ...e1Strings, ipType: e1Strings.ipType });
  };

  const { data: dhcp8021xData, isLoading: dhcp8021xLoading, fetchData: fetchDHCP8021xConfig } = useUnifiedFetch(
    boxDetails?._id ? `boxes/${boxDetails._id}/viewDHCP8021x` : null,
    false // Don't auto-fetch, we'll trigger it manually
  );

  const { data: dnsData, isLoading: dnsLoading, fetchData: fetchDnsCheck } = useUnifiedFetch(
    boxDetails?._id ? `boxes/${boxDetails._id}/dnscheck` : null,
    !!boxDetails?._id
  );

  const { data: mtuData, isLoading: mtuLoading, fetchData: fetchMtuCheck } = useUnifiedFetch(
    boxDetails?._id ? `boxes/${boxDetails._id}/mtucheck` : null,
    !!boxDetails?._id
  );

  const { data: dot1xStatusData, fetchData: fetchDot1XStatus } = useUnifiedFetch(
    boxDetails?._id ? `boxes/${boxDetails._id}/dot1XStatus` : null,
    false
  );

  const handleDeactivateE1 = async () => {
    const divElement = document.getElementById('test-time-remaining');
    const isHidden = divElement.getAttribute('hidden') !== null;
    if (isHidden) {
      setDcUpdatePopup({ show: true });
    } else {
      if (e1Strings.enabled) {
        const res = await dispatch(deactivateE2(token, boxDetails._id));
        // eslint-disable-next-line no-console
        console.log('checking deactivate e2 response', res);
        if (res) {
          if (e1Strings.enabled) {
            // [Action]-Disable
            dispatch(disableAction('E1 IP Type change from enable to disable'));
          } else {
            // [Action] - Enable
            dispatch(enableAction('E1 IP Type change from disabled to enabled'));
          }
        }
        props.getBoxData()
      }
      setE1Strings({ ...e1Strings, enabled: !e1Strings.enabled });
    }
  };

  const unLockBoxButton = async () => {
    const element = document.getElementById('test-lock-icon');
    if (element) {
      // Simulate a click event
      element.click();
    } else {
      console.error('Element with id "test-lock-icon" not found.');
    }
  };

  const handleDeactivateE2 = async () => {
    const divElement = document.getElementById('test-time-remaining');
    const isHidden = divElement.getAttribute('hidden') !== null;
    if (isHidden) {
      setDcUpdatePopup({ show: true });
    } else {
      setToggleLoading(true);
      if (DHCPStatus) {
        const res = await dispatch(disableDHCP(token, boxDetails.vpnAddress));
        // eslint-disable-next-line no-console
        console.log('checking deactivate e2 response', res);
        if (res) {
          const result = res.toLowerCase().includes('disab');
          setDHCPStatus(!result);
          dispatch(disableAction('E2 DHCP change from enable to disable'));
          addNote({ boxID: boxDetails._id, note: "E2 DHCP change from enable to disable"});
        }
      } else {
        const res = await dispatch(enableDHCP(token, boxDetails.vpnAddress));
        if (res) {
          const result = res.toLowerCase().includes('enable');
          setDHCPStatus(result);
          dispatch(enableAction('E2 DHCP change from disabled to enabled'));
          addNote({ boxID: boxDetails._id, note: "E2 DHCP change from disable to enable"});
        }
      }
      setToggleLoading(false);
    }
  };

  const dhcpStatus = async () => {
    const response = await dispatch(getDhcp(token, boxDetails.vpnAddress));
    if (response) {
      const result = response.toLowerCase().includes('enable');
      setDHCPStatus(result);
    }
  };

  const getNetworkStatus = async () => {
    setIsLoading(true);
    const data = await dispatch(getNetworkConnectivatyStatus(token, boxDetails?._id));
    if (data) {
      setNetworkInfo(data);
    }
    setIsLoading(false);
  };
  const handleSaveOutboundLowMtu = async () => {
    const divElement = document.getElementById('test-time-remaining');
    const isHidden = divElement?.getAttribute('hidden') !== null;
    if (isHidden) {
      setDcUpdatePopup({ show: true });
      return;
    }
    setOutboundLowMtuSaving(true);
    try {
      const payload = {
        enable: outboundLowMtuEnabled,
        mtu: outboundLowMtuEnabled ? Number(outboundLowMtuValue) : null,
      };
      const res = await dispatch(updateLowMtu(token, boxDetails._id, payload));
      if (res && res.apiRes.statusCode == 200) {
        toast.success(res.apiRes.response);
        addNote({
          boxID: boxDetails._id,
          note: `Outbound Low MTU ${payload.enable ? `enabled (MTU ${payload.mtu})` : 'disabled'}`,
        });
        if (Number(outboundLowMtuValue) === 1420) {
          setLockLowMtuUI(true);
          setOutboundLowMtuEnabled(false);
        } else {
          setLockLowMtuUI(false);
        }
        props.getBoxData();
      }
    } catch (error) {
      console.error('Error saving Outbound Low MTU:', error);
      toast.error('Failed to update Outbound Low MTU');
    } finally {
      setOutboundLowMtuSaving(false);
    }
  };

  const submitOutboundLowMtu = async (enabled, mtu) => {
    const divElement = document.getElementById('test-time-remaining');
    const isHidden = divElement?.getAttribute('hidden') !== null;
    if (isHidden) {
      setDcUpdatePopup({ show: true });
      return false;
    }
  
    setOutboundLowMtuSaving(true);
    try {
      const payload = { enabled, mtu };
      const res = await dispatch(updateLowMtu(token, boxDetails._id, payload));
  
      if (res?.apiRes?.statusCode === 200) {
        toast.success(res.apiRes.response);
        return true;
      }
      toast.error(res?.apiRes?.response || 'Failed to update Outbound Low MTU');
      return false;
    } catch (e) {
      console.error(e);
      toast.error('Failed to update Outbound Low MTU');
      return false;
    } finally {
      setOutboundLowMtuSaving(false);
    }
  };
  

  // Helper function to calculate if message should be shown based on timestamp
  const shouldShowMessage = (timestamp, status) => {
    if (!timestamp || !status) return false;
    
    const elapsed = Date.now() - new Date(timestamp).getTime();
    const maxTotalDuration = 240000; // 2 minutes polling + 2 minutes display = 4 minutes total
    
    // Show message if status is resolved (not pending) and within 4 minutes of timestamp
    if (status !== 'pending' && elapsed < maxTotalDuration) {
      return { shouldShow: true, remainingTime: maxTotalDuration - elapsed };
    }
    
    return { shouldShow: false, remainingTime: 0 };
  };

  const startHideTimer = (remainingTime) => {
    // Clear any existing hide timer
    if (dot1xHideTimer) {
      clearTimeout(dot1xHideTimer);
    }
    
    if (remainingTime > 0) {
      // Set timer to hide status message after remaining time
      const hideTimer = setTimeout(() => {
        setDot1xStatusMessage(null);
        setDot1xHideTimer(null);
      }, remainingTime);
      
      setDot1xHideTimer(hideTimer);
    }
  };

  useEffect(() => {
    dhcpStatus();
    if (!boxDetails.myEpik) {
      getNetworkStatus();
    }
    
  }, []);

  // Check for pending dot1x status on mount and resume polling if needed
  useEffect(() => {
    const checkPendingStatus = async () => {
      if (boxDetails?._id && e1Strings.ipType === 'dhcp_8021x' && !dot1xPollingInterval) {
        try {
          const response = await fetchDot1XStatus();
          if (response?.status !== false) {
            const dot1x = response?.dot1x || response;
            if (dot1x && dot1x.status === 'pending' && dot1x.timestamp) {
              // Check if timestamp is within 2 minutes
              const elapsed = Date.now() - new Date(dot1x.timestamp).getTime();
              const maxDuration = 120000; // 2 minutes
              if (elapsed < maxDuration) {
                // Resume polling with the timestamp
                startDot1XPolling(dot1x.timestamp);
              } else {
                // Timestamp expired - timeout occurred, show timeout message
                setDot1xRemainingTime(null);
                const message = { status: 'timeout', message: 'Request timed out. Please check manually.' };
                setDot1xStatusMessage(message);
                // Calculate remaining display time (2 minutes display after timeout)
                const maxTotalDuration = 240000; // 2 minutes polling + 2 minutes display = 4 minutes total
                const remainingTime = Math.max(0, maxTotalDuration - elapsed);
                if (remainingTime > 0) {
                  startHideTimer(remainingTime);
                }
              }
            } else if (dot1x && dot1x.status !== 'pending' && dot1x.timestamp) {
              // Status is already resolved, check if message should still be shown based on timestamp
              const result = shouldShowMessage(dot1x.timestamp, dot1x.status);
              if (result.shouldShow) {
                // Show message based on status
                if (dot1x.status === 'success') {
                  setDot1xStatusMessage({ status: 'success', message: dot1x.response || '802.1x configuration successful' });
                  startHideTimer(result.remainingTime);
                } else if (dot1x.status === 'failed') {
                  setDot1xStatusMessage({ status: 'failed', message: dot1x.response || '802.1x configuration failed' });
                  startHideTimer(result.remainingTime);
                }
              }
            }
          }
        } catch (error) {
          console.error('Error checking pending dot1x status:', error);
        }
      }
    };
    
    if (boxDetails?._id) {
      checkPendingStatus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [boxDetails?._id, e1Strings.ipType]);

  // Cleanup: clear intervals and timers on unmount
  useEffect(() => {
    return () => {
      if (dot1xPollingInterval) {
        clearInterval(dot1xPollingInterval);
      }
      if (dot1xTimerInterval) {
        clearInterval(dot1xTimerInterval);
      }
      if (dot1xHideTimer) {
        clearTimeout(dot1xHideTimer);
      }
    };
  }, [dot1xPollingInterval, dot1xTimerInterval, dot1xHideTimer]);

  useEffect(() => {
    simStatus();
    setEth3Value(boxDetails?.eth3Disable);
    
    // Update e1Strings when boxDetails changes
    if (boxDetails?.e2) {
      const ipType = boxDetails.e2.ipType || (boxDetails.e2.enabled ? 'static' : 'dhcp');
      const identity = boxDetails.e2.identity || '';
      const password = boxDetails.e2.password || '';
      const phase2 = boxDetails.e2.phase2 || 'PEAP';
      
      setE1Strings({
        ...boxDetails.e2,
        ipType: ipType,
        identity: identity,
        password: password,
        phase2: phase2,
      });
      
      // If 802.1x is selected and credentials exist, mark them as saved
      if (ipType === 'dhcp_8021x' && identity && password) {
        setAreCredentialsSaved(true);
        setIsEditing8021x(false);
      } else if (ipType !== 'dhcp_8021x') {
        // Reset credentials saved state when not using 802.1x
        setAreCredentialsSaved(false);
        setIsEditing8021x(false);
      }
    }
  }, [boxDetails]);
  useEffect(() => {
    if (outboundLowMtuSaving) return;
    let isMounted = true;
    const fetchLowMtu = async () => {
      try {
        const res = await dispatch(getLowMtu(token, boxDetails._id));
        const lm = res?.lowMtu;
        if (isMounted && lm) {
          setOutboundLowMtuValue(lm.mtu);
          if (Number(lm.mtu) === 1420 && Boolean(lm.enabled)) {
            setLockLowMtuUI(true);
            setOutboundLowMtuEnabled(false);
          } else {
            setLockLowMtuUI(false);
            setOutboundLowMtuEnabled(Boolean(lm.enabled));
          }
        }
      } catch (err) {
      }
    };

    if (token && boxDetails?._id) fetchLowMtu();

    return () => {
      isMounted = false;
    };
  }, [dispatch, token, boxDetails?._id, outboundLowMtuSaving]);

  const normalizedLowMtuOptions = useMemo(() => {
    const base = OUTBOUND_LOW_MTU_OPTIONS.map(Number);
    const current =
      outboundLowMtuValue === "" || outboundLowMtuValue === null || outboundLowMtuValue === undefined
        ? null
        : Number(outboundLowMtuValue);

    if (current !== null && !base.includes(current)) {
      return [current, ...base];
    }
    return base;
  }, [outboundLowMtuValue]);

  // Fetch DHCP 802.1x config when component loads and IP type is dhcp_8021x
  useEffect(() => {
    if (boxDetails?._id && e1Strings.ipType === 'dhcp_8021x') {
      fetchDHCP8021xConfig();
    }
  }, [boxDetails?._id, e1Strings.ipType]);

  // Handle DHCP 802.1x data when it's fetched
  useEffect(() => {
    if (dhcp8021xData?.response) {
      // Parse the response to extract user, password, and EAP method (phase2)
      const responseText = dhcp8021xData.response;
      const userMatch = responseText.match(/User:\s*(.+)/);
      const passMatch = responseText.match(/Pass:\s*(.+)/);
      // Extract EAP method from "EAP : PEAP" or "EAP : TTLS" format
      const eapMatch = responseText.match(/EAP\s*:\s*(PEAP|TTLS)/);
      
      if (userMatch && passMatch) {
        const user = userMatch[1].trim();
        const password = passMatch[1].trim();
        // Keep saved phase2 when device response has no EAP line (do not force PEAP)
        const phase2 = eapMatch ? eapMatch[1].trim() : (boxDetails?.e2?.phase2 || 'PEAP');
        
        setE1Strings(prev => ({
          ...prev,
          identity: user,
          password: password,
          phase2: phase2,
        }));
        // Mark credentials as saved since they came from database
        setAreCredentialsSaved(true);
      }
    }
  }, [dhcp8021xData]);

  useEffect(() => {
    const isStaticValid = e1Strings.ipType === 'static' && 
      e1Strings.IP?.length > 0 && 
      e1Strings.subnet?.length > 0 && 
      e1Strings.gateway?.length > 0;
    
    const is8021xValid = e1Strings.ipType === 'dhcp_8021x' && 
      e1Strings.identity?.length > 0 && 
      e1Strings.password?.length > 0;
    
    // DHCP doesn't need validation since it's handled automatically
    const isValid = isStaticValid || is8021xValid;
    
    setEnableE1Btn(!isValid);
  }, [e1Strings]);

  const one2InputChange = name => {
    const lastLetter = name.target.value.charAt(name.target.value?.length - 1);
    const numberCheck = !isNaN(lastLetter);
    if (numberCheck || lastLetter === '.') {
      setE1Strings({ ...e1Strings, [name.target.name]: name.target.value });
    } else {
      toast.error('Please enter number or dot');
    }
  };

  const checkDot1XStatus = async () => {
    try {
      const response = await fetchDot1XStatus();
      
      // Handle error response from useUnifiedFetch
      if (response?.status === false) {
        console.error('Error checking dot1X status:', response.message);
        return { statusChanged: false, dot1x: null };
      }
      
      const dot1x = response?.dot1x || response;
      
      if (dot1x && dot1x.status) {
        // If status is no longer pending, stop polling and show message
        if (dot1x.status !== 'pending') {
          // Clear the interval
          if (dot1xPollingInterval) {
            clearInterval(dot1xPollingInterval);
            setDot1xPollingInterval(null);
          }
          
          // Clear timer
          if (dot1xTimerInterval) {
            clearInterval(dot1xTimerInterval);
            setDot1xTimerInterval(null);
          }
          setDot1xStartTime(null);
          dot1xTimestampRef.current = null;
          setDot1xRemainingTime(null);
          
          // Show status/response message and start hide timer based on timestamp
          if (dot1x.status === 'success') {
            toast.success(dot1x.response || '802.1x configuration successful');
            const message = { status: 'success', message: dot1x.response || '802.1x configuration successful' };
            setDot1xStatusMessage(message);
            // Calculate remaining display time from timestamp (2 minutes polling + 2 minutes display = 4 minutes total)
            if (dot1x.timestamp) {
              const elapsed = Date.now() - new Date(dot1x.timestamp).getTime();
              const maxTotalDuration = 240000; // 4 minutes total
              const remainingTime = Math.max(0, maxTotalDuration - elapsed);
              startHideTimer(remainingTime);
            } else {
              startHideTimer(120000); // Default 2 minutes if no timestamp
            }
          } else if (dot1x.status === 'failed') {
            toast.error(dot1x.response || '802.1x configuration failed');
            const message = { status: 'failed', message: dot1x.response || '802.1x configuration failed' };
            setDot1xStatusMessage(message);
            // Calculate remaining display time from timestamp
            if (dot1x.timestamp) {
              const elapsed = Date.now() - new Date(dot1x.timestamp).getTime();
              const maxTotalDuration = 240000; // 4 minutes total
              const remainingTime = Math.max(0, maxTotalDuration - elapsed);
              startHideTimer(remainingTime);
            } else {
              startHideTimer(120000); // Default 2 minutes if no timestamp
            }
          }
          
          return { statusChanged: true, dot1x };
        }
        // Still pending, return dot1x with timestamp
        return { statusChanged: false, dot1x };
      }
      return { statusChanged: false, dot1x: null };
    } catch (error) {
      console.error('Error checking dot1X status:', error);
      return { statusChanged: false, dot1x: null };
    }
  };

  const startDot1XPolling = (initialTimestamp = null) => {
    // Clear any existing intervals
    if (dot1xPollingInterval) {
      clearInterval(dot1xPollingInterval);
    }
    if (dot1xTimerInterval) {
      clearInterval(dot1xTimerInterval);
    }
    
    // Set start time - use provided timestamp or current time
    const startTime = initialTimestamp ? new Date(initialTimestamp).getTime() : Date.now();
    setDot1xStartTime(startTime);
    if (initialTimestamp) {
      dot1xTimestampRef.current = initialTimestamp;
    }
    const maxDuration = 120000; // 2 minutes in milliseconds
    
    // Calculate remaining time based on timestamp
    const calculateRemainingTime = (timestamp) => {
      if (!timestamp) {
        if (startTime) {
          const elapsed = Date.now() - startTime;
          return Math.max(0, maxDuration - elapsed);
        }
        return null;
      }
      const elapsed = Date.now() - new Date(timestamp).getTime();
      const remaining = Math.max(0, maxDuration - elapsed);
      return remaining;
    };
    
    // Set initial remaining time
    const initialRemaining = calculateRemainingTime(initialTimestamp);
    if (initialRemaining !== null) {
      setDot1xRemainingTime(initialRemaining);
      // If already expired, don't start polling
      if (initialRemaining <= 0) {
        return;
      }
    } else {
      setDot1xRemainingTime(maxDuration);
    }
    
    // Timer interval to update remaining time display (every second)
    const timerInterval = setInterval(() => {
      const ts = dot1xTimestampRef.current || initialTimestamp;
      const remaining = calculateRemainingTime(ts);
      if (remaining !== null) {
        setDot1xRemainingTime(remaining);
        if (remaining <= 0) {
          clearInterval(timerInterval);
          setDot1xTimerInterval(null);
          setDot1xRemainingTime(null); // Clear remaining time so status message can show
        }
      }
    }, 1000); // Update every second
    
    setDot1xTimerInterval(timerInterval);
    
    // Polling interval to check status (every 5 seconds)
    const pollingInterval = setInterval(async () => {
      const result = await checkDot1XStatus();
      
      // If status changed, stop polling
      if (result.statusChanged) {
        clearInterval(pollingInterval);
        clearInterval(timerInterval);
        setDot1xPollingInterval(null);
        setDot1xTimerInterval(null);
        setDot1xStartTime(null);
        dot1xTimestampRef.current = null;
        // Note: Status message and hide timer are set in checkDot1XStatus
        return;
      }
      
      // Update timestamp if we got a new one from the response
      if (result.dot1x && result.dot1x.timestamp) {
        dot1xTimestampRef.current = result.dot1x.timestamp;
      }
      
      // Check if we've exceeded max duration
      const currentTimestamp = dot1xTimestampRef.current || initialTimestamp;
      const elapsed = currentTimestamp 
        ? Date.now() - new Date(currentTimestamp).getTime()
        : Date.now() - startTime;
      
      if (elapsed >= maxDuration) {
        clearInterval(pollingInterval);
        clearInterval(timerInterval);
        setDot1xPollingInterval(null);
        setDot1xTimerInterval(null);
        setDot1xStartTime(null);
        dot1xTimestampRef.current = null;
        setDot1xRemainingTime(null);
        toast.warning('802.1x status check timed out. Please check manually.');
        // Set timeout message and start hide timer based on timestamp
        const message = { status: 'timeout', message: 'Request timed out. Please check manually.' };
        setDot1xStatusMessage(message);
        // Calculate remaining display time from the original timestamp (2 minutes display after timeout)
        const currentTimestamp = dot1xTimestampRef.current || initialTimestamp;
        if (currentTimestamp) {
          const elapsed = Date.now() - new Date(currentTimestamp).getTime();
          const maxTotalDuration = 240000; // 2 minutes polling + 2 minutes display = 4 minutes total
          const remainingTime = Math.max(0, maxTotalDuration - elapsed);
          startHideTimer(remainingTime);
        } else {
          startHideTimer(120000); // Default 2 minutes if no timestamp
        }
      }
    }, 5000); // 5 seconds interval
    
    setDot1xPollingInterval(pollingInterval);
  };

  const handleE2Save = async () => {
    setSaveLoading(true);
    setDot1xStatusMessage(null); // Clear previous status message
    try {
      let payload = {};
      let actionText = '';
      
      // Create clean payload based on selected IP type
      if (e1Strings.ipType === 'static') {
        payload = {
          enabled: true,
          IP: e1Strings.IP,
          subnet: e1Strings.subnet,
          gateway: e1Strings.gateway,
          ipType: 'static',
          identity: '',
          password: '',
        };
        actionText = boxDetails?.e2.IP && !e1Strings.IP ? 'Static E1 IP Type added' : 'Static E1 IP Type changed';
      } else if (e1Strings.ipType === 'dhcp_8021x') {
        payload = {
          enabled: true,
          IP: '',
          subnet: '',
          gateway: '',
          ipType: 'dhcp_8021x',
          identity: e1Strings.identity,
          password: e1Strings.password,
          phase2: e1Strings.phase2 || 'PEAP',
        };
        actionText = 'DHCP + Wired auth (802.1x) E1 IP Type configured';
      }
      
      const res = await dispatch(activateE2(token, boxDetails._id, payload));
      if (res) {
        if (boxDetails?.e2.IP && !e1Strings.IP) {
          // [Action] - Add
          dispatch(addAction(actionText));
        } else {
          // [Action] - Change
          dispatch(changeAction(actionText));
        }
        
        // Check if response contains dot1x object with pending status
        if (res.dot1x && res.dot1x.status === 'pending') {
          // Start polling for dot1x status with timestamp
          // Don't set status message for pending - let the timer display handle it
          startDot1XPolling(res.dot1x.timestamp);
        } else if (res.dot1x && res.dot1x.status !== 'pending') {
          // If status is already success or failed, show message immediately
          if (res.dot1x.status === 'success') {
            toast.success(res.dot1x.response || '802.1x configuration successful');
            const message = { status: 'success', message: res.dot1x.response || '802.1x configuration successful' };
            setDot1xStatusMessage(message);
            // Calculate remaining display time from timestamp
            if (res.dot1x.timestamp) {
              const elapsed = Date.now() - new Date(res.dot1x.timestamp).getTime();
              const maxTotalDuration = 240000; // 4 minutes total
              const remainingTime = Math.max(0, maxTotalDuration - elapsed);
              startHideTimer(remainingTime);
            } else {
              startHideTimer(120000); // Default 2 minutes if no timestamp
            }
          } else if (res.dot1x.status === 'failed') {
            toast.error(res.dot1x.response || '802.1x configuration failed');
            const message = { status: 'failed', message: res.dot1x.response || '802.1x configuration failed' };
            setDot1xStatusMessage(message);
            // Calculate remaining display time from timestamp
            if (res.dot1x.timestamp) {
              const elapsed = Date.now() - new Date(res.dot1x.timestamp).getTime();
              const maxTotalDuration = 240000; // 4 minutes total
              const remainingTime = Math.max(0, maxTotalDuration - elapsed);
              startHideTimer(remainingTime);
            } else {
              startHideTimer(120000); // Default 2 minutes if no timestamp
            }
          }
        }
      }
      props.getBoxData();
      // Reset editing state after successful save
      if (e1Strings.ipType === 'dhcp_8021x') {
        setIsEditing8021x(false);
        setAreCredentialsSaved(true);
      }
    } catch (error) {
      console.error('Error saving E1 configuration:', error);
    } finally {
      setSaveLoading(false);
    }
  };

  const onEnableE2Toggle = async () => {
    if (updatedBoxDetails.e3) {
      const result = await dispatch(deactivateE3(token, boxDetails._id));
      if (result) {
        setUpdatedBoxDetails({ ...updatedBoxDetails, e3: !updatedBoxDetails.e3 });
        await dispatch(disableAction(`E2 toggle disabled`));
      }
    } else {
      const result = await dispatch(activateE3(token, boxDetails._id));
      if (result) {
        await dispatch(enableAction(`E2 toggle enabled`));
        setUpdatedBoxDetails({ ...updatedBoxDetails, e3: !updatedBoxDetails.e3 });
        setE2Toggle(true);
      }
    }
  };

  const onPortForwardPress = async () => {
    setPortLoading(true);
    const portListData = await dispatch(getPortList(token, boxDetails._id));
    setPortList(portListData);
    setPortLoading(false);
  };

  useMemo(() => {
    // eslint-disable-next-line no-unused-expressions
    !!portList?.length && setForwardingModal(true);
  }, [portList]);

  const onCallback = async (obj, type, index) => {
    setForwardingModal(false);
    // setIsExpandingBox(true);

    if (type === 'update') {
      const res = await dispatch(updatePortForward(token, boxDetails._id, index, obj));
      if (res) {
        // [Action]- Change
        dispatch(changeAction('update port forward'));
      }
    } else {
      const res = await dispatch(addPortForward(token, boxDetails._id, obj));
      if (res) {
        if (type === 'save') {
          // [Action]- Add
          dispatch(addAction('add port forwarding'));
        } else if (type === 'delete') {
          // [Action]- Change
          dispatch(changeAction('remove port forwarding'));
        }
      }
    }

    // setIsExpandingBox(false);
    setForwardingModal(true);
  };

  const simStatus = async () => {
    if (!boxDetails?.myEpik) {
      const data = await dispatch(eSIMStatus(token, boxDetails._id));
      if (typeof data === 'boolean') {
        setESIMStatus(data);
      } else {
        setESIMStatus(null);
      }
    }
  };

  const onInputChange = e => {
    setWifiStatus({ ...wifiStatus, [e.target.name]: e.target.value });
  };

  const isNumberKey = React.useCallback(evt => {
    const charCode = evt?.which ? evt?.which : evt?.keyCode;
    if (charCode !== 46 && charCode > 31 && (charCode < 48 || charCode > 57)) return false;
    return true;
  }, []);

  const checkThirdOctet = parseInt(boxDetails?.vpnAddress?.split('.')[2], 10) >= 20;

  const refreshConnectivityStats = async () => {
    if (!boxDetails?.myEpik) {
      setIsLoading(true);
      await dispatch(triggerConnectivityStats(token, boxDetails._id));
      setIsLoading(false);
    }
  };

  const [networkInfoLoading, setNetworkInfoLoading] = useState(false)
  const [refreshDhcpLoading, setRefreshDhcpLoading] = useState(false)

  const [dhcpInfoLoading, setDhcpInfoLoading] = useState(false)
  const [dhcpRequestLoading, setDhcpRequestLoading] = useState(false)
  const [saveLoading, setSaveLoading] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const [isEditing8021x, setIsEditing8021x] = useState(false)
  // Check if credentials are already saved in boxDetails
  const [areCredentialsSaved, setAreCredentialsSaved] = useState(
    boxDetails?.e2?.ipType === 'dhcp_8021x' && 
    boxDetails?.e2?.identity && 
    boxDetails?.e2?.password
  )

  // Check if 802.1x credentials are already set (from database)
  const are8021xCredentialsSet = areCredentialsSaved;

  const onRefreshNetworkInfo = async e => {
    e.preventDefault()
    setNetworkInfoLoading(true)
    await dispatch(fetchNetworkInfo(token, boxDetails?.vpnAddress));
    setTimeout(() => {
      setNetworkInfoLoading(false)
    }, 400);
  };

  const onRefreshDhcp = async e => {
    e.preventDefault()
    setRefreshDhcpLoading(true)
    await dispatch(refreshDhcp(token, boxDetails?.vpnAddress));
    setTimeout(() => {
      setRefreshDhcpLoading(false)
    }, 400);
  };

  const eth3PasswordHandler = () => {
    setWarningModal(true);
    setPasswordModal(false)
    setWarningModalText(ETH3_WARNING_TEXT);
    setPasswordModal(false)
  }
  const [e3loading, setE3Loading] = useState(false);
  const [eth3Value, setEth3Value] = useState(boxDetails?.eth3Disable);
  const onChangeEth3Value = async () => {
    const updatedEth3Value = !eth3Value;
    setWarningModal(false)
    setWarningModalText('')
    setE3Loading(true);
    const res = await dispatch(enableDisableEth3(token, boxDetails._id, boxDetails?.vpnAddress, updatedEth3Value))
    // const res = true
    console.log('res is ', res)
    if (res) {
      setEth3Value(updatedEth3Value)

      const note = `Eth0/3 ${eth3Value ? 'enabled' : 'disabled'}`
      addNote({ boxID: boxDetails._id, note });
    }
    setTimeout(() => {
      setE3Loading(false)
    }, 400)

  }

  return (
    <>
      <div className="optionsContainer">
        {isLoading && <Spinner />}
        <h1 className="font-weight-bold">{boxDetails?.networkInterfaceInfo?.eth0 ? 'Network Interface Info' : 'Network'}</h1>
        {(user.role != 'admin' &&
          user.role != 'enterpriseAdmin' ) && (
        <>
          {boxDetails?.networkInterfaceInfo?.eth0?.mac && ( 
            <Row>
              <Col sm={12} md={12}>
              <table className="network-interface-info-table">
                  <tr>
                    <th>Eth0 </th>
                    <th style={{ textAlign: 'center' }}>IP</th>
                    <th style={{ textAlign: 'center' }}>MAC Address</th>
                  </tr>
                  <tr>
                    <td></td>
                    <td>{boxDetails?.networkInterfaceInfo?.eth0?.ip}</td>
                    <td>{boxDetails?.networkInterfaceInfo?.eth0?.mac}</td>
                  </tr>
                </table>
              </Col>
            </Row>
          )}
          <Row className='mb-3'>
          <Col sm={12} md={4}>
            {networkInfoLoading ? <SpinnerCircles red />
              : <Button color="primary" onClick={onRefreshNetworkInfo} title={'Fetch network info'}>
                Refresh Info
              </Button>}
          </Col>
          </Row>
          

          {eth3Access && <Row className='mb-2'>
            <Col sm={6} md={4} id="test-enable-expansion-box" className="type-header d-flex">
              Enable Eth0/3
              <sup>
                <InfoPopup id="enable-exp-module" text={TOOLTIPS_TEXT.DISABLE_E3} />
              </sup>
            </Col>

            <Col sm={2} style={{ display: 'flex', verticalAlign: 'middle' }}>
              {e3loading ? (
                <SpinnerCircles red />
              ) : (
                <Toggle
                  id="e3-switch-toggle"
                  disabled={eth3Access === 'read' || e3loading}
                  value={!eth3Value}
                  onToggle={async toggleValue => {
                    if (eth3Access === 'write' || eth3Access === 'both') {
                      await onChangeEth3Value();
                    }
                  }}
                />
              )}
            </Col>
          </Row>}
        </>)}
        <Row>
          <Col sm={12} md={12}>
            <div hidden={boxDetails?.myEpik}>
              <Row className="network-input-container">
                <Col sm={6} className="d-flex">
                  E1 IP Type
                  <sup>
                    <InfoPopup id="e1-ip" text={TOOLTIPS_TEXT.E1_IP_TYPE} />
                  </sup>
                </Col>
                <Col sm={6}>
                  <Row>
                    <Col sm={10}>
                      <div style={{ position: 'relative' }}>
                        <select
                          className="form-control"
                          value={e1Strings.ipType}
                          onChange={(e) => handleE1IpTypeChange({ value: e.target.value })}
                          disabled={user?.readOnly || dhcpRequestLoading}
                        >
                          {e1IpTypeOptions.map(option => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </select>
                        {dhcpRequestLoading && (
                          <div style={{ 
                            position: 'absolute', 
                            right: '10px', 
                            top: '50%', 
                            transform: 'translateY(-50%)',
                            zIndex: 10
                          }}>
                            <SpinnerCircles red />
                          </div>
                        )}
                      </div>
                    </Col>
                    <Col sm={2} className="d-flex align-items-center justify-content-center">
                      {refreshDhcpLoading ? (
                        <SpinnerCircles red />
                      ) : (
                        <div className="reload-toggle" onClick={onRefreshDhcp} title="Refresh DHCP">
                          <FontAwesomeIcon icon={faRedo} className="fa-icon" />
                        </div>
                      )}
                    </Col>
                  </Row>
                </Col>
              </Row>
              
              {e1Strings.ipType === 'static' && (
                <Row className="e2-input-container">
                  <Col md={4} lg={3} className="pr-0">
                    <Label>Ip Address:</Label>
                    <Input
                      placeholder="Please specify"
                      value={e1Strings.IP}
                      type="text"
                      name="IP"
                      onChange={one2InputChange}
                      onkeypress={isNumberKey}
                    />
                  </Col>
                  <Col md={4} lg={3} className="pr-0">
                    <label>Subnet:</label>
                    <Input
                      placeholder="Please specify"
                      value={e1Strings.subnet}
                      type="text"
                      name="subnet"
                      onChange={one2InputChange}
                    />
                  </Col>
                  <Col md={4} lg={3} className="pr-0">
                    <Label>Gateway:</Label>
                    <Input
                      placeholder="Please specify"
                      value={e1Strings.gateway}
                      type="text"
                      name="gateway"
                      onChange={one2InputChange}
                    />
                  </Col>
                  <Col md={4} lg={3} className="e2-btn-container">
                    {saveLoading ? (
                      <SpinnerCircles red />
                    ) : (
                      <Button disabled={enableE1Btn} color="primary" onClick={handleE2Save}>
                        Save
                      </Button>
                    )}
                  </Col>
                </Row>
              )}
              
              {e1Strings.ipType === 'dhcp_8021x' && (
                <Row className="e2-input-container">
                  <Col md={4} lg={3} className="pr-0">
                    <Label>Identity:</Label>
                    <div style={{ position: 'relative' }}>
                      <Input
                        placeholder="Please specify"
                        value={e1Strings.identity}
                        type="text"
                        name="identity"
                        onChange={(e) => handle8021xFieldChange('identity', e.target.value)}
                        disabled={dhcp8021xLoading || (are8021xCredentialsSet && !isEditing8021x)}
                        style={{ 
                          backgroundColor: (are8021xCredentialsSet && !isEditing8021x) ? '#f8f9fa' : 'white',
                          color: (are8021xCredentialsSet && !isEditing8021x) ? '#6c757d' : 'black'
                        }}
                      />
                      {dhcp8021xLoading && (
                        <div style={{ 
                          position: 'absolute', 
                          right: '10px', 
                          top: '50%', 
                          transform: 'translateY(-50%)',
                          zIndex: 10
                        }}>
                          <SpinnerCircles red />
                        </div>
                      )}
                    </div>
                  </Col>
                  <Col md={4} lg={3} className="pr-0">
                    <Label>Password:</Label>
                    <div style={{ position: 'relative' }}>
                      <Input
                        placeholder="Please specify"
                        value={e1Strings.password}
                        type={showPassword ? "text" : "password"}
                        name="password"
                        onChange={(e) => handle8021xFieldChange('password', e.target.value)}
                        disabled={dhcp8021xLoading || (are8021xCredentialsSet && !isEditing8021x)}
                        style={{ 
                          backgroundColor: (are8021xCredentialsSet && !isEditing8021x) ? '#f8f9fa' : 'white',
                          color: (are8021xCredentialsSet && !isEditing8021x) ? '#6c757d' : 'black',
                          paddingRight: '40px'
                        }}
                      />
                      {!dhcp8021xLoading && (
                        <div style={{ 
                          position: 'absolute', 
                          right: '10px', 
                          top: '50%', 
                          transform: 'translateY(-50%)',
                          zIndex: 10,
                          cursor: 'pointer'
                        }} onClick={toggleShowPassword}>
                          <FontAwesomeIcon 
                            icon={showPassword ? faEyeSlash : faEye} 
                            size="lg" 
                            color="#8998ac" 
                          />
                        </div>
                      )}
                      {dhcp8021xLoading && (
                        <div style={{ 
                          position: 'absolute', 
                          right: '10px', 
                          top: '50%', 
                          transform: 'translateY(-50%)',
                          zIndex: 10
                        }}>
                          <SpinnerCircles red />
                        </div>
                      )}
                    </div>
                  </Col>
                  <Col md={4} lg={4} className="pr-0">
                    <Label>Phase2:</Label>
                    <Input
                      type="select"
                      value={e1Strings.phase2 || 'PEAP'}
                      onChange={(e) => handle8021xFieldChange('phase2', e.target.value)}
                      disabled={dhcp8021xLoading || (are8021xCredentialsSet && !isEditing8021x)}
                      style={{ 
                        backgroundColor: (are8021xCredentialsSet && !isEditing8021x) ? '#f8f9fa' : 'white',
                        color: (are8021xCredentialsSet && !isEditing8021x) ? '#6c757d' : 'black'
                      }}
                    >
                      <option value="PEAP">PEAP (MSCHAPv2)</option>
                      <option value="TTLS">TTLS (MD5)</option>
                    </Input>
                  </Col>
                  <Col md={4} lg={2} className="e2-btn-container">
                    {saveLoading ? (
                      <SpinnerCircles red />
                    ) : are8021xCredentialsSet && !isEditing8021x ? (
                      <div style={{ display: 'flex', gap: '5px' }}>
                        <Button 
                          color="secondary" 
                          size="sm" 
                          onClick={handleEdit8021x}
                          disabled={dhcp8021xLoading}
                        >
                          Edit
                        </Button>
                        <Button 
                          color="outline-danger" 
                          size="sm" 
                          onClick={handleClear8021x}
                          disabled={dhcp8021xLoading}
                        >
                          Clear
                        </Button>
                      </div>
                    ) : (
                      <Button 
                        disabled={enableE1Btn || dhcp8021xLoading} 
                        color="primary" 
                        onClick={handleE2Save}
                      >
                        {are8021xCredentialsSet ? 'Update' : 'Save'}
                      </Button>
                    )}
                  </Col>
                </Row>
              )}
              
              {/* Display dot1x status message and timer */}
              {(dot1xStatusMessage || (dot1xRemainingTime !== null && dot1xRemainingTime > 0)) && e1Strings.ipType === 'dhcp_8021x' && (
                <Row className="mt-2">
                  <Col sm={12}>
                    {/* Show timer if polling is active (remaining time > 0) */}
                    {dot1xRemainingTime !== null && dot1xRemainingTime > 0 ? (
                      <div style={{
                        padding: '10px',
                        borderRadius: '4px',
                        backgroundColor: '#d1ecf1',
                        border: '1px solid #bee5eb',
                        color: '#0c5460'
                      }}>
                        <strong>802.1x Status:</strong> Pending... 
                        <span style={{ marginLeft: '10px', fontWeight: 'bold' }}>
                          Time remaining: {Math.floor(dot1xRemainingTime / 60000)}:{(Math.floor((dot1xRemainingTime % 60000) / 1000)).toString().padStart(2, '0')}
                        </span>
                      </div>
                    ) : dot1xStatusMessage && dot1xStatusMessage.status !== 'pending' ? (
                      // Show status message only if not pending (success, failed, or timeout)
                      <div style={{
                        padding: '10px',
                        borderRadius: '4px',
                        backgroundColor: dot1xStatusMessage.status === 'success' ? '#d4edda' : 
                                         dot1xStatusMessage.status === 'failed' ? '#f8d7da' : 
                                         dot1xStatusMessage.status === 'timeout' ? '#fff3cd' : '#fff3cd',
                        border: `1px solid ${dot1xStatusMessage.status === 'success' ? '#c3e6cb' : 
                                 dot1xStatusMessage.status === 'failed' ? '#f5c6cb' : 
                                 dot1xStatusMessage.status === 'timeout' ? '#ffeaa7' : '#ffeaa7'}`,
                        color: dot1xStatusMessage.status === 'success' ? '#155724' : 
                               dot1xStatusMessage.status === 'failed' ? '#721c24' : 
                               dot1xStatusMessage.status === 'timeout' ? '#856404' : '#856404'
                      }}>
                        <strong>802.1x Status:</strong> {dot1xStatusMessage.message}
                      </div>
                    ) : null}
                  </Col>
                </Row>
              )}
              
            </div>
            {(user.role != 'admin' &&
              user.role != 'enterpriseAdmin' ) && (
              <>
            <br />
            <div hidden={boxDetails?.myEpik}>
              {toggleLoading ? (
                <div>
                  <SpinnerCircles red />
                </div>
              ) : (
                <NetworkInput
                  tooltipId="e2-dhcp"
                  tooltipText={TOOLTIPS_TEXT.E2_DHCP}
                  header="E2 DHCP"
                  onToggle={handleDeactivateE2}
                  value={DHCPStatus}
                  leftToggle="OFF"
                  rightToggle="ON"
                />
              )}
            </div>
            <br />
            {!boxDetails.myEpik && checkThirdOctet && (
              <Row>
                <Col id="call-recording-toggle" className="d-flex" sm={6}>
                  Port Forwarding:
                  <sup>
                    <InfoPopup id="port-forwading" text={TOOLTIPS_TEXT.PORT_FORWARD} />
                  </sup>
                </Col>
                <Col sm={6}>
                  {portLoading ? (
                    <SpinnerCircles red />
                  ) : (
                    <Button color="primary" onClick={onPortForwardPress}>
                      Port Forwarding
                    </Button>
                  )}
                </Col>
              </Row>
            )}
            </>
            )}
          </Col>
          {(user.role != 'admin' &&
          user.role != 'enterpriseAdmin' ) && (
          <>
          {showWifiSection && !isModelGen4 && (
            <Col sm={12} md={6}>
              <h1 className="font-weight-bold">WIFI Network</h1>
              <NetworkInput disabled header="Status" value={wifiStatus?.Status} name="apn" input />
              <NetworkInput
                disabled={wifiStatus?.Status === 'Enabled'}
                header="SSID Name"
                value={wifiStatus?.SSID}
                name="SSID"
                onChange={onInputChange}
                input
              />

              <NetworkInput
                disabled={wifiStatus?.Status === 'Enabled'}
                header="Mode"
                dropdownOptions={modeDropDown}
                selectedOption={mode}
                onOptionSelect={e => handleDropDownChange(e, 'Mode')}
              />
              <NetworkInput
                disabled={wifiStatus?.Status === 'Enabled'}
                header="Security Options"
                dropdownOptions={secDropDown}
                selectedOption={sec}
                onOptionSelect={e => handleDropDownChange(e, 'Sec_Mode')}
              />

              <NetworkInput disabled header="IP" value={wifiStatus?.IP} name="IP" input />
              <NetworkInput
                disabled
                header="Subnet"
                value={wifiStatus?.Subnet}
                name="Subnet"
                input
              />
              <NetworkInput
                disabled
                header="Gateway"
                value={wifiStatus?.Gateway}
                name="Gateway"
                input
              />
              <NetworkInput
                disabled={wifiStatus?.Status === 'Enabled' || wifiStatus?.Sec_Mode === 'None'}
                header="Password"
                value={wifiStatus?.Password}
                showEye={wifiStatus?.Mode === 'AP'}
                name="Password"
                onChange={onInputChange}
                input
              />
              <Button color="primary" 
                  onClick={ (e) => {
                    const divElement = document.getElementById('test-time-remaining');
                    const isHidden = divElement.getAttribute('hidden') !== null;
                    if (isHidden) {
                      setDcUpdatePopup({ show: true });
                    } else {
                      handleConnectDisconnect(e)
                    }
        
                  }}
                >
                {loading ? (
                  <SpinnerCircles />
                ) : wifiStatus?.Status === 'Enabled' ? (
                  'Disconnect'
                ) : (
                  'Connect'
                )}
              </Button>
            </Col>
          )}
          </>
        )}
        </Row>
        {(user.role != 'admin' &&
        user.role != 'enterpriseAdmin' ) && (
        <>
        {!boxDetails.myEpik && (
          <>
            <Row>
              <Col col={12} sm={12} md={7}>
                <div>
                  <h1 className="headingnetwork-table">MTU CHECK</h1>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <span>MTU Check:</span>
                    {mtuLoading ? (
                      <SpinnerCircles red />
                    ) : mtuData && typeof mtuData['MTU Check Passed'] === 'boolean' ? (
                      <span style={{ 
                        color: mtuData['MTU Check Passed'] ? 'green' : 'red',
                        fontWeight: 'bold'
                      }}>
                        {mtuData['MTU Check Passed'] ? 'Passed' : 'Failed'}
                      </span>
                    ) : (
                      <span style={{ color: 'gray' }}>Unable to fetch MTU Check</span>
                    )}
                  </div>
                </div>
              </Col>
            </Row>
          </>
        )}
            {(outboundLowMTU === 'read' || outboundLowMTU === 'both') && (
              <div style={{ marginTop: '12px' }}>
                <Row className="align-items-center">
                  <Col sm={12} className="d-flex align-items-center" style={{ gap: '12px' }}>
                    <span style={{ whiteSpace: 'nowrap' }}>Outbound Low MTU:</span>

                    <Toggle
                      id="outbound-low-mtu-toggle"
                      disabled={outboundLowMtuSaving || outboundLowMTU === 'read'}
                      value={outboundLowMtuEnabled}
                      onToggle={async () => {
                        if (outboundLowMtuSaving) return;
                        if (lockLowMtuUI) {
                          setLockLowMtuUI(false);
                          setOutboundLowMtuEnabled(true);
                          setOutboundLowMtuValue("");
                          return;
                        }
                        if (outboundLowMtuEnabled) {
                          setOutboundLowMtuEnabled(false);
                          setOutboundLowMtuValue("");
                          const ok = await submitOutboundLowMtu(false, null);
                          if (!ok) {
                            setOutboundLowMtuEnabled(true);
                            setOutboundLowMtuValue(String(boxDetails?.outboundLowMtu?.mtu || ""));
                          }
                          return;
                        }

                        setOutboundLowMtuEnabled(true);
                        setOutboundLowMtuValue("");
                        if (!outboundLowMtuValue) setOutboundLowMtuValue('');
                      }}
                    />

                    <span style={{ fontSize: '12px', color: '#6c757d', whiteSpace: 'nowrap' }}>
                      {outboundLowMtuEnabled ? 'Enabled' : 'Disabled'}
                    </span>

                    {(outboundLowMtuEnabled || lockLowMtuUI) && (
                      <>
                        <div style={{ width: '170px' }}>
                          <Input
                            disabled={outboundLowMtuSaving || outboundLowMTU === 'read' || lockLowMtuUI}
                            type="select"
                            value={outboundLowMtuValue}
                            onChange={(e) => setOutboundLowMtuValue(Number(e.target.value))}
                          >
                            <option value="" disabled>Select</option>
                            {normalizedLowMtuOptions.map(v => (
                              <option key={v} value={v}>
                                {v}{!OUTBOUND_LOW_MTU_OPTIONS.includes(v)}
                              </option>
                            ))}
                          </Input>
                        </div>

                        {outboundLowMtuSaving ? (
                          <SpinnerCircles red />
                        ) : (
                          !lockLowMtuUI && (
                            <Button
                              color="primary"
                              disabled={!outboundLowMtuValue || outboundLowMTU === 'read'}
                              onClick={handleSaveOutboundLowMtu}
                            >
                              Save
                            </Button>
                          )
                        )}
                      </>
        )}
      </Col>
    </Row>
  </div>
)}
        {!boxDetails.myEpik && networkInfo && (
          <>
            {networkInfo && (() => {
              // Check if there's an error in networkInfo
              const hasError = networkInfo?.error;
              
              // Check if networkInfo is an empty object or has no meaningful data
              const locationKeys = Object.keys(networkInfo).filter(
                key => key !== 'Timestamp' && key !== 'error'
              );
              
              // Check if networkInfo is empty or has no location data
              const isEmptyResponse = locationKeys.length === 0 || 
                locationKeys.every(key => !networkInfo[key] || Object.keys(networkInfo[key] || {}).length === 0);
              
              if (isEmptyResponse) {
                return (
                  <Row>
                    <Col col={12} sm={12} md={7}>
                      <div>
                        <h1 className="headingnetwork-table">
                          EPIK DC CONNECTIVITY
                        </h1>
                        <div style={{ 
                          color: 'red', 
                          padding: '20px', 
                          textAlign: 'center', 
                          backgroundColor: '#fff3f3', 
                          border: '1px solid #ffcdd2',
                          borderRadius: '4px',
                          marginTop: '10px'
                        }}>
                          {hasError || `Please run EPIK Updates or try initiating the test.`}
                        </div>
                      </div>
                    </Col>
                  </Row>
                );
              }

              // Dynamically get all interfaces from the response
              const allInterfaces = [];
              locationKeys.forEach(loc => {
                const interfaces = Object.keys(networkInfo[loc] || {});
                interfaces.forEach(iface => {
                  if (!allInterfaces.includes(iface)) {
                    allInterfaces.push(iface);
                  }
                });
              });

              const getCell = (loc, intf) => {
                const iface = networkInfo[loc]?.[intf];

                if (!iface) {
                  return { color: 'red', tooltip: iface?.Description };
                }

                if (iface.Status === 'Open') {
                  return { color: 'green', tooltip: iface?.Description };
                }

                if (iface.Status === 'Closed') {
                  const description = iface?.Description || '';
                  // Yellow for CLOSED with ICMP in description
                  if (description.includes('ICMP test passed but the UDP test failed')) {
                    return { color: 'yellow', tooltip: description };
                  }
                  // Red for all other CLOSED status
                  return { color: 'red', tooltip: description };
                }

                // Default to red for any other cases
                return { color: 'red', tooltip: iface?.Description };
              };

              const colorToEmoji = {
                green: '🟢',
                yellow: '🟡',
                red: '🔴',
              };

              let dnsColor = '';
              if (!dnsLoading && dnsData?.response !== undefined) {
                dnsColor = dnsData.response ? 'green' : 'red';
              }
              
              return (
                <Row>
                  <Col col={12} sm={12} md={7}>
                    <div>
                      <h1 className="headingnetwork-table">
                        EPIK DC CONNECTIVITY
                        {!hasError && (
                          <>
                            {' - ['}
                            <span style={networkInfo.Timestamp && utils.isOlderThan24Hours(networkInfo.Timestamp) ? { color: 'red', fontWeight: 500 } : {}}>
                              {networkInfo.Timestamp}
                            </span>
                            {']'}
                          </>
                        )}
                        {hasError && (
                          <span style={{ color: 'red', marginLeft: '10px', fontSize: '0.9em' }}>
                            - {hasError}
                          </span>
                        )}
                      </h1>
                        <table className="network-status-table">
                          <thead>
                            <tr className="full-filltable-row">
                              <th className="text-secondary">Name</th>
                              {locationKeys.map(loc => (
                                <th className="text-secondary" key={loc}>{loc}</th>
                              ))}
                              <th className="text-secondary">DNS</th>
                            </tr>
                          </thead>
                          <tbody>
                            {allInterfaces.map((intf, idx) => (
                              <tr className="full-filltable-row" key={intf}>
                                <td>{intf}</td>
                                {locationKeys.map(loc => {
                                  const cell = getCell(loc, intf);
                                  return (
                                    <td key={loc}>
                                      {cell.tooltip ? (
                                        <span id={`network-light-${intf}-${loc}`} style={{ fontSize: '1.5em', position: 'relative' }}>
                                          <TooltipCustom
                                            tipId={`network-light-${intf}-${loc}`}
                                            displayData={cell.tooltip}
                                            placement="top"
                                          />
                                          {colorToEmoji[cell.color]}
                                        </span>
                                      ) : (
                                        <span id={`network-light-${intf}-${loc}`} style={{ fontSize: '1.5em' }}>{colorToEmoji[cell.color]}</span>
                                      )}
                                    </td>
                                  );
                                })}
                                {idx === 0 && (
                                  <td rowSpan={allInterfaces.length} style={{ verticalAlign: 'middle', textAlign: 'center' }}>
                                    {dnsColor ? <span id={`network-light-dns`} style={{ fontSize: '1.5em' }}>{colorToEmoji[dnsColor]}</span> : ''}
                                  </td>
                                )}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                    </div>
                  </Col>
                </Row>
              );
            })()}
          </>
        )}
        </>
        )}
        <CustomModal
          header="Port Forward"
          wider
          isOpen={forwardingModal}
          onCancel={() => setForwardingModal(false)}
        >
          <PortForwardUpdate callback={onCallback} boxId={boxDetails._id} />
        </CustomModal>
        <ConfirmationModal
        bodyText={'You are attempting to make changes to a device that is not currently locked for editing. To prevent conflicting changes, please lock the device before proceeding.'}
        headerText={'Device Lock Required'}
        confirmBtnText={'Lock & Edit'} 
        close={'No'} 
        isOpen={dcUpdatePopup.show}
        onCancel={() => {
          setDcUpdatePopup({ show: false, value: {} });
        }}
        onConfirm={() => {
          unLockBoxButton();
          setDcUpdatePopup({ show: false, value: {} });
        }}
      />
      </div>
      {(user.role != 'admin' &&
        user.role != 'enterpriseAdmin' ) && (
        <>
      <div className="connectionButtonsContainer d-flex justify-content-end align-items-center w-100">
        <Button
          className="connectionButton mr-3"
          id="data-check-tip"
          color="primary"
          onClick={() => {
            getNetworkStatus();
            fetchDnsCheck();
          }}
        >
          Fetch Result
        </Button>
        <div className="mr-3" onClick={refreshConnectivityStats}>
        <div className="reload-toggle">
          <FontAwesomeIcon icon={faRedo} className="fa-icon" />
        </div>
        </div>
      </div>
      </>
      )}
      {warningModal && <ConfirmationModal
        isOpen={warningModal}
        onCancel={() => {
          setWarningModalText('');
          setWarningModal(false);
        }}
        confirmBtnText={'Proceed'}
        bodyText={warningModalText}
        // subHeader={currentModalData.type === 'datacenter' ? currentModalData?.subHeader : null}
        headerText={"Eth3 Port disabling"}
        onConfirm={onChangeEth3Value}
      />}

      {show8021xWarning && <ConfirmationModal
        isOpen={show8021xWarning}
        onCancel={handle8021xWarningCancel}
        confirmBtnText={'Continue'}
        bodyText={'Warning: If LTE is down and connection is not authorized, you will lose connection to the Epik Device.'}
        headerText={'802.1x Authentication Warning'}
        onConfirm={handle8021xWarningConfirm}
      />}

      {passwordModal && <AddSecurityCodeModal
        isOpen={passwordModal}
        onConfirm={eth3PasswordHandler}
        onCancel={() => setPasswordModal(false)}
        featureName={PIN_CODES_NAME.eth3Disable}
      />}
    </>
  );
});

export default EpikboxNetworking;
